export default class PrivacyView {
    constructor(parent, router) {
        this.router = router;
        this.parent = parent;
        this.el = parent.el.querySelector('.privacy-view');

        this.acceptCta = this.el.querySelector('#privacy-accept');
        this.declineCta = this.el.querySelector('#privacy-decline');
        this.backLink = this.el.querySelector('#back-to-intro');
        this.accordionWrapper = this.el.querySelectorAll('.accordion');

        this.bind();
        this.accordion();
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    bind() {
        this.acceptCta.addEventListener('click', (e) => {
            e.preventDefault();

            this.analyticsPush(e.currentTarget, this.parent.order?.summary?.ids?.modelCode);
            this.router.update('eligibility');
        });

        this.backLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.router.update('intro');
        });
    }

    accordion() {
        this.accordionWrapper.forEach((element) => {
            const accordionItems = element.querySelectorAll('.accordion--title');

            accordionItems.forEach((item) => {
                item.addEventListener('click', (e) => {
                    const accordionClicked = e.target;

                    accordionClicked.parentElement.classList.toggle('open');
                    accordionClicked.parentElement.nextElementSibling.classList.toggle('hide');
                });
            });
        });
    }

    analyticsPush(el, model) {
        this.parent.AnalyticsHelper.template(el, { model });
        this.parent.AnalyticsHelper.push(el);
    }
}
